


















































































import Vue from 'vue';
import Component from 'vue-class-component';
import DataTableWithDialog from '@/components/DataTableWithDialog.vue';
import TextInput from '@/components/TextInput.vue';
import { mapModelLike } from '@/store/util';
import { Prop } from 'vue-property-decorator';
import { reversedEnum, translatedEnumOptions } from '@/i18n';
import {
  SpellCategory, SpellDuration, SpellKind, SpellRange,
} from '@/model';
import { Spell } from '@/store/SpellsStore';
import HeaderAddon from './SpellsBoxHeaderAddon.vue';

@Component({
  components: { DataTableWithDialog, TextInput },
  computed: mapModelLike('spells', ['items', 'tradition']),
})
export default class SpellsBox extends Vue {
  @Prop(Boolean) readonly editMode: boolean | undefined;

  static defaultHeight = 5;

  static optional = true;

  static readonly HeaderAddon = HeaderAddon;

  spellKinds = translatedEnumOptions(SpellKind, 'spells.kinds');

  spellCategories = translatedEnumOptions(SpellCategory, 'spells.categories');

  spellRanges = translatedEnumOptions(SpellRange, 'spells.ranges');

  spellDurations = translatedEnumOptions(SpellDuration, 'spells.durations');

  displayDuration(spell: Spell) {
    return this.$t(`spells.durationMnemonics.${reversedEnum(SpellDuration)[spell.duration]}`)
      .toString();
  }

  displayRange(spell: Spell) {
    return this.$t(`spells.rangeMnemonics.${reversedEnum(SpellRange)[spell.range]}`).toString();
  }

  displayKind(spell: Spell) {
    return this.spellKinds.find((e) => e.value === spell.kind)!!.text.toString()[0];
  }

  displayCategory(spell: Spell) {
    return this.spellCategories.find((e) => e.value === spell.category)!!.text.toString();
  }

  get headers() {
    return [{
      text: this.$t('name'),
      align: 'start',
      sortable: true,
      value: 'name',
    }, {
      text: this.$t('spells.category'),
      align: 'start',
      sortable: true,
      value: 'category',
    }, {
      text: this.$t('spells.kind'),
      align: 'start',
      sortable: true,
      value: 'kind',
    }, {
      text: this.$t('spells.range'),
      align: 'start',
      sortable: true,
      value: 'range',
    }, {
      text: this.$t('spells.duration'),
      align: 'start',
      sortable: false,
      value: 'duration',
    }, {
      text: this.$t('spells.drain'),
      align: 'end',
      sortable: false,
      value: 'drain',
    },
    ];
  }
}

